import { render } from "./Footer.vue?vue&type=template&id=9af61bb8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=9af61bb8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9af61bb8"

export default script